import { SubscriptionBillingCycle } from '@air/api/types';
import { createStateContext } from 'react-use';

const [useBillingCycle, BillingCycleProvider] = createStateContext<SubscriptionBillingCycle>('annual');

export { BillingCycleProvider, useBillingCycle };
